import { IEmployeeModulesConfig } from "../Types/UserProfileDetails";

export interface EligibleDateRange {
  minDate?: string;
  maxDate?: string;
  isBypassedRole: boolean;
}

export const getConfigEligibleDateRange = (
  employeeModuleConfig: IEmployeeModulesConfig | null | undefined,
  loginEmployeeRole?: string
): EligibleDateRange => {
  const config = employeeModuleConfig?.conveyance;
  if (!config) return { isBypassedRole: false };

  const eligibleFrom = config.eligible_date_range?.from;
  const eligibleTo = config.eligible_date_range?.to;
  const bypassRoles = config.bypass_roles || [];
  const isBypassedRole =
    !!loginEmployeeRole &&
    bypassRoles.includes(loginEmployeeRole.toLowerCase());

  return {
    minDate: eligibleFrom,
    maxDate: eligibleTo,
    isBypassedRole,
  };
};
